import { useRef, useState } from 'react';
import { segment } from '@actions/analytics';
import { useDispatchToStore } from '@hooks/reduxHooks';
import { toggleEnrolledCourse } from '@actions/courses';
import {
  evtNameCategoryMap,
  getCourseEnrollMessage,
  programmeTypes
} from '@constants/index';
import { useSnackbar } from '@stores/snackbar';
import {
  COURSE_ENROLLED,
  COURSE_UNENROLLED,
  COURSE_KEYS
} from '@constants/segment';
import { useSelectedGoalUID } from '@api/hooks/topology/useSelectedGoal';

const useEnroll = ({ isRecordedGoal = false }) => {
  const dispatch = useDispatchToStore();
  const selectedCourse = useRef(null);
  const segmentDataRef = useRef({});
  const selectedGoalUID = useSelectedGoalUID();
  const { open: showSnackbar } = useSnackbar();

  const [isUnEnrollModalOpen, setIsUnEnrollModalOpen] = useState(false);
  const toggleEnroll =
    (courseData) =>
    (courseUid, isEnrolled, segmentData = {}) => {
      if (isEnrolled) {
        segmentDataRef.current = segmentData;
        selectedCourse.current = courseData;
        setIsUnEnrollModalOpen(true);
      } else {
        const { uid, name } = courseData?.goal || {};
        dispatch(toggleEnrolledCourse(courseUid, !isEnrolled)).then((res) => {
          if (res.result)
            segment.track(
              COURSE_ENROLLED,
              segmentData,
              evtNameCategoryMap.WITHOUT_CATEGORY,
              true,
              COURSE_KEYS
            );

          showSnackbar({
            message: getCourseEnrollMessage({
              type:
                courseData?.courseType === programmeTypes.TESTSERIES
                  ? 'Test-series'
                  : 'Course',
              goalUID: uid,
              selectedGoalUID,
              goalName: name,
              isRecordedGoal
            }),
            type: 'success'
          });
        });
      }
    };
  const acceptOnClick = () => {
    dispatch(toggleEnrolledCourse(selectedCourse.current.uid, false)).then(
      (res) => {
        if (res.result)
          segment.track(
            COURSE_UNENROLLED,
            segmentDataRef.current,
            evtNameCategoryMap.WITHOUT_CATEGORY,
            true,
            COURSE_KEYS
          );
        segmentDataRef.current = {};
      }
    );
    setIsUnEnrollModalOpen(false);
  };
  const onCloseModal = () => {
    setIsUnEnrollModalOpen(false);
    selectedCourse.current = null;
  };
  const result = useRef({
    isUnEnrollModalOpen,
    setIsUnEnrollModalOpen,
    toggleEnroll,
    acceptOnClick,
    onCloseModal
  });
  result.current.isUnEnrollModalOpen = isUnEnrollModalOpen;
  return result.current;
};

export default useEnroll;
